window.appConfig = APP_CONFIG;
window.themeColors = THEME_COLORS;
Object.freeze(window.appConfig);
